import { Table, Badge } from 'react-bootstrap';

const inventory = [
  { sku: 'WH-001', name: 'Wireless Headphones', stock: 24 },
  { sku: '4K-009', name: '4K Monitor', stock: 8 },
  { sku: 'GM-200', name: 'Gaming Mouse', stock: 52 },
];

export default function Inventory() {
  return (
    <>
      <h3 className="mb-3">Inventory</h3>
      <Table hover responsive>
        <thead>
          <tr>
            <th>SKU</th>
            <th>Name</th>
            <th>Stock</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {inventory.map((item) => (
            <tr key={item.sku}>
              <td>{item.sku}</td>
              <td>{item.name}</td>
              <td>{item.stock}</td>
              <td>
                <Badge bg={item.stock < 10 ? 'warning' : 'success'}>
                  {item.stock < 10 ? 'Low' : 'Healthy'}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}

